<template>
  <div class="aside">
    <!-- <el-menu
      default-active="$route.path"
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#545c64"
      text-color="#fff"
      router 
      active-text-color="#ffd04b">
      <template v-for="(e,i) in menuList">
        <el-menu-item v-if="!e.children" :index="e.path">
          <i :class="e.icon"></i>
          <span slot="title">{{e.authName}}</span>
        </el-menu-item>
        <el-submenu v-if="e.children" :index="e.path">
          <template slot="title">
            <i :class="e.icon"></i>
            <span>{{e.authName}}</span>
          </template>

          <el-submenu v-if="ce.children" v-for="(ce,ci) in e.children" :index="ce.path">
            
            <template slot="title">
              <i :class="e.icon"></i>
              <span>{{ce.authName}}</span>
            </template>
            <el-menu-item v-for="(cce,cci) in ce.children" :index="cce.path">
              <i :class="e.icon"></i>
              <span slot="title">{{cce.authName}}</span>
            </el-menu-item>
          </el-submenu>

          <el-menu-item-group v-for="(ce,ci) in e.children" v-if="!ce.children">
            <el-menu-item :index="ce.path">
              <i :class="e.icon"></i>
              <span slot="title">{{ce.authName}}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </template>
    </el-menu> -->
    <template v-if="isAside">
      <div :class="asideClass">
        <div
          v-for="(e, i) in asideList"
          :key="i"
          @click="asideClick(e.children, i, e.text, e.url)"
          :class="isAsideone !== i ? 'asidelist' : 'asidelist active'"
          :style="{
            background:
              isAsideone !== i
                ? ''
                : isCustoms
                ? customColors
                : isSimple
                ? '#DE4D35 !important'
                : '#185ED3 !important',
          }"
        >
          <div v-if="isAsideone != i" class="icon" :style="{backgroundImage:'url(' + e.src +')'}"></div>
          <div v-if="isAsideone === i" class="icon" :style="{backgroundImage:'url(' + e.srcw + ')'}"></div>
          <!-- <img
            v-if="isAsideone != i"
            width="20px"
            height="20px"
            :src="e.src"
            alt=""
          />
          <img
            v-if="isAsideone === i"
            width="20px"
            height="20px"
            :src="e.srcw"
            alt=""
          /> -->
          <p>{{ e.text }}</p>
        </div>

        <div
          v-if="powersObj.browseDownload && powersObj.allowTransmit"
          class="download"
          @click="goDown"
          :style="{
            height: isCustom ? '40px !important' : '36px !important',
            background: isCustom ? custom == 'xugong' ? 'url(' +
                require('@/assets/custom/xg-download.png') +
                ') no-repeat' : 'url(' +
                require('@/assets/custom/wc-download.png') +
                ') no-repeat' : isSimple
              ? 'url(' +
                require('@/assets/house/simpleDown.png') +
                ') no-repeat'
              : 'url(' + require('@/assets/house/Down.png') + ') no-repeat',
            backgroundSize: 'cover',
          }"
        ></div>
      </div>
      <template v-if="isChildren">
        <div
          v-for="(e, i) in children"
          :key="i"
          :class="isClick ? 'asideright fadein' : 'asideright fadeout'"
        >
          <div>
            <div class="title">
              <p style="font-weight: bolder">{{ e.text }}</p>
            </div>

            <div
              v-for="(ce, ci) in e.children"
              :key="ci"
              @click="cechildrenClick(ci, ce.url)"
              :class="isAsidetwo !== ci ? 'twoaside' : 'twoaside active'"
            >
              <p>{{ ce.text }}</p>
            </div>
          </div>
        </div>
      </template>
    </template>

    <div
      :class="hidasideClass"
      :style="{
        backgroundColor: isCustoms
          ? customColors
          : isSimple
          ? '#DE4D35'
          : '#185ED3',
      }"
      v-if="!isAside"
    >
      <div
        @mouseover="hidasidemouseover"
        @mouseout="hidasidemouseout"
        :style="{
          backgroundColor: isCustoms
            ? customColors
            : isSimple
            ? '#DE4D35'
            : '#185ED3',
        }"
        :class="hidasideinsideclass"
      >
        <div
          v-for="(e, i) in hidasideList"
          :key="i"
          @click="hidasideclick(i, e.url, e.text)"
          :class="isAsideone !== i ? 'hidimg' : 'hidimg active'"
        >
          <el-tooltip
            class="item"
            effect="dark"
            :content="e.text"
            placement="right"
          >
            <div v-if="isAsideone !== i" class="icon" :style="{backgroundImage:'url(' + e.src +')'}"></div>
            <div v-if="isAsideone === i" class="icon" :style="{backgroundImage:'url(' + e.clicksrc + ')'}"></div>
            <!-- <img v-if="isAsideone !== i" :src="e.src" alt="" />
            <img v-if="isAsideone === i" :src="e.clicksrc" alt="" /> -->
          </el-tooltip>
        </div>
      </div>
    </div>

    <div
      v-if="isGundong"
      :style="{
        backgroundColor: isCustoms
          ? customColors
          : isSimple
          ? '#DE4D35'
          : '#185ED3',
      }"
      class="replacehidaside"
    ></div>
  </div>
</template>

<script>
import getIsSimple from "@/constants/simple";
import { powersObj, allowLib, allowPushChannel } from "@/constants/powers";
export default {
  props: {
    asideList: Array,
    hidasideList: Array,
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        let dontVerify = [
          "/pictureUpload",
          "/desktop/myPictureNeed",
        ];
        let myFullPath = val.fullPath;
        if (
          val.fullPath === "/pictureUpload" ||
          val.fullPath === "/desktop/myPictureNeed" 
        ) {
          this.isClick = false;
          this.isChildren = false;
        }
        console.log('值值值-----',val);
       
        // if (val.fullPath.indexOf("/myLib/show") !== -1) {
        //   myFullPath = "/myLib/myMediaAll";
        // }
        if (val.fullPath.indexOf("/pictureLive/livePic") !== -1) {
          myFullPath = "/pictureLive/manage";
        }
        if (val.fullPath.indexOf("seepersonface") !== -1) {
          myFullPath = "/myLib/peopleManage";
        }
        
        if (val.fullPath.indexOf("/pictureCenter/atlas/show") !== -1) {
          myFullPath = "/pictureCenter";
        }
        if (val.fullPath.indexOf("/addword") !== -1) {
          myFullPath = "/pictureCenter";
        }
        if (val.fullPath.indexOf("/mediaResult") !== -1) {
          myFullPath = "/pictureCenter";
        }
        if (val.fullPath === "/container") {
          myFullPath = "/desktop/contributor";
        }
        
        // console.log(myFullPath)
        if (!this.isAsideClick && dontVerify.indexOf(myFullPath) === -1) {
          if (this.isAside) {
            for (let i = 0; i < this.asideList.length; i++) {
              if (!this.asideList[i].children) {
                this.children = [
                  {
                    text: "",
                    children: [],
                  },
                ];
                this.isChildren = false;
                this.isClick = false;
                if (myFullPath === this.asideList[i].url) {
                  this.isAsideone = i;
                  return false;
                }
              } else {
                this.isAsideone = i;
                this.isChildren = true;
                this.isClick = true;
                for (let j = 0; j < this.asideList[i].children.length; j++) {
                  if (myFullPath === this.asideList[i].children[j].url) {
                    this.children[0].children = this.asideList[i].children;
                    this.children[0].text = this.asideList[i].text;
                    this.isAsidetwo = j;
                    // console.log(this.isChildren)
                    return false;
                  }
                }
              }
            }
          } else {
            for (let i = 0; i < this.hidasideList.length; i++) {
              if (!this.asideList[i].children) {
                this.children = [
                  {
                    text: "",
                    children: [],
                  },
                ];
                if (myFullPath === this.hidasideList[i].url) {
                  this.isAsideone = i;
                  return false;
                }
              } else {
                this.isAside = true;
                this.isAsideone = i;
                this.isChildren = true;
                this.isClick = true;
                for (let j = 0; j < this.asideList[i].children.length; j++) {
                  if (myFullPath === this.asideList[i].children[j].url) {
                    this.children[0].children = this.asideList[i].children;
                    this.children[0].text = this.asideList[i].text;
                    this.isAsidetwo = j;
                    // console.log(this.isChildren)
                    return false;
                  }
                }
              }
            }
          }
        }
      },
      // 深度观察监听
      deep: true,
    },
    $route: {
      handler: function (to, from){
        
        // if (to.fullPath.indexOf("/myLib/show") !== -1) {
        //    let myFullPath = from?from.fullPath:;
        // }
        console.log('tototo',to);
        console.log('fromfff',from);
      },
      immediate:true
    }
  },
  data() {
    return {
      getIsSimple,
      simple: true,
      isCustoms: false,
      customColors: "",
      customs: "",

      powersObj,

      isAsideClick: false, //如果点击侧边栏就不检测路由
      isAside: true, //layout页面转递过来的 用来判断是否收起侧边栏
      isAsideone: 0, //判断点击之后侧边栏的一级图片样式 （收起和展开 实现联动）
      isAsidetwo: 0, //如果一级侧边栏有二级 判断二级的点击样式
      isChildren: false, //判断一级侧边栏是否有二级
      isClick: false, // 判断是否点击一级侧边栏
      isGundong: false, //判断是否滚动
      children: [
        {
          text: "",
          children: [],
        },
      ], //用于存储二级侧边栏

      hidasideClass: "hidasidetransition",
      asideClass: "asideleft asidetransition",
      hidasideinsideclass: "hidaside",
    };
  },
  methods: {
    getSimple() {
      getIsSimple().then((res) => {
        if (res.isCustom) {
          this.isCustoms = res.isCustom;
          this.customColors = res.customColor;
          this.customs = res.custom;
        } else {
          this.isCustoms = false;
          this.customColors = res.customColor;
          this.customs = res.custom;
        }
        if (typeof res.isSimple !== "undefined") {
          this.simple = res.isSimple;
        } else {
          this.simple = true;
        }
      });
    },

    asideClick(children, i, text, url) {
      this.isAsideClick = true;
      let path = this.$route.path;

      if (children !== undefined) {
        this.isChildren = true;

        if (this.children[0].text === text) {
          this.isClick = !this.isClick;
        } else {
          this.isAsidetwo = 0;
          this.children[0].children = children;
          this.children[0].text = text;
          this.isClick = true;
          this.$router.push({
            path: url,
          });
        }
      } else {
        this.children = [
          {
            text: "",
            children: [],
          },
        ];
        this.isChildren = false;
        this.isClick = false;
        this.$router.push({
          path: url,
        });
      }
      this.isAsideone = i;

      setTimeout(() => {
        this.isAsideClick = false;
      }, 1000);
    },
    cechildrenClick(i, url) {
      this.isAsidetwo = i;
      // console.log(url)
      this.$router.push({
        path: url,
        params: {
          page: "1",
          code: "8989",
        },
      });
    },
    hidasideclick(i, url, text) {
      this.isAsideone = i;
      this.isAsideClick = true;
      let path = this.$route.path;
      if (this.asideList[i].children) {
        this.isAside = true;
        if (this.children[0].text === text) {
          this.isClick = true;
        } else {
          this.isAsidetwo = 0;
          this.children = [
            {
              text: "",
              children: [],
            },
          ];
          this.children[0].children = this.asideList[i].children;
          this.children[0].text = this.asideList[i].text;
          this.isChildren = true;
          this.isClick = true;
          this.$router.push({
            path: url,
          });
        }

        this.bus.$emit("changeIsaside", this.isAside);
      } else {
        this.children = [];
        this.$router.push({
          path: url,
        });
      }

      setTimeout(() => {
        this.isAsideClick = false;
      }, 1000);
    },
    hidasidemouseover() {
      // this.isAside = true
    },
    hidasidemouseout() {
      // this.isAside = false
    },

    refHandler(val, oldVal) {
      let dontVerify = [
        "/pictureUpload",
        "/desktop/myPictureNeed",
      ];
      let myFullPath = val.fullPath;
      if (
        val.fullPath === "/pictureUpload" ||
        val.fullPath === "/desktop/myPictureNeed"
      ) {
        this.isClick = false;
        this.isChildren = false;
      }
      if (val.fullPath.indexOf("/pictureLive/livePic") !== -1) {
        myFullPath = "/pictureLive/manage";
      }
      if (val.fullPath.indexOf("/shareAndPush/myDownload") !== -1) {
        myFullPath = "/desktop/contributor";
      }
      if (val.fullPath.indexOf("/myLib/show") !== -1) {
        if (val.fullPath.indexOf("myMediaAll") !== -1) {
          myFullPath = "/myLib/myMediaAll";
        } else if (val.fullPath.indexOf("checkPass") !== -1) {
          myFullPath = "/myLib/checkPass";
        } else if(val.fullPath.indexOf("sendCheck") !== -1){
          myFullPath = "/myLib/sendCheck";
          
        } else if (val.fullPath.indexOf("noPass") !== -1) {
          myFullPath = "/myLib/noPass";
          
        } else if (val.fullPath.indexOf("checkCenter") !== -1) {
          myFullPath = "/checkCenter";
        }else if (val.fullPath.indexOf("shareAndPush") !== -1) {
          myFullPath = "/digitalCenter/downloadLog";
        }
        
        
      }
      if (val.fullPath.indexOf('/config/pointRecord')!==-1) {
        if (val.fullPath.indexOf('baseConfig')!==-1) {
          myFullPath = "/config/userManage"
        } else {
          myFullPath = "/desktop/contributor";
        }
      }
      if (val.fullPath.indexOf("seepersonface") !== -1) {
        myFullPath = "/myLib/peopleManage";
      }
      if (val.fullPath.indexOf("/pictureCenter/atlas/show") !== -1) {
        myFullPath = "/pictureCenter";
      }
      if (val.fullPath.indexOf("/mediaResult") !== -1) {
          myFullPath = "/pictureCenter";
        }
      if (val.fullPath.indexOf("/addword") !== -1) {
        myFullPath = "/pictureCenter";
      }
      if (val.fullPath === "/container") {
        myFullPath = "/desktop/contributor";
      }
      // console.log(myFullPath)
      if (!this.isAsideClick && dontVerify.indexOf(myFullPath) === -1) {
        if (this.isAside) {
          for (let i = 0; i < this.asideList.length; i++) {
            if (!this.asideList[i].children) {
              this.children = [
                {
                  text: "",
                  children: [],
                },
              ];
              this.isChildren = false;
              this.isClick = false;
              if (myFullPath === this.asideList[i].url) {
                this.isAsideone = i;
                return false;
              }
            } else {
              this.isAsideone = i;
              this.isChildren = true;
              this.isClick = true;
              for (let j = 0; j < this.asideList[i].children.length; j++) {
                if (myFullPath === this.asideList[i].children[j].url) {
                  this.children[0].children = this.asideList[i].children;
                  this.children[0].text = this.asideList[i].text;
                  this.isAsidetwo = j;
                  // console.log(this.isChildren)
                  return false;
                }
              }
            }
          }
        } else {
          for (let i = 0; i < this.hidasideList.length; i++) {
            if (!this.asideList[i].children) {
              this.children = [
                {
                  text: "",
                  children: [],
                },
              ];
              if (myFullPath === this.hidasideList[i].url) {
                this.isAsideone = i;
                return false;
              }
            } else {
              this.isAside = true;
              this.isAsideone = i;
              this.isChildren = true;
              this.isClick = true;
              for (let j = 0; j < this.asideList[i].children.length; j++) {
                if (myFullPath === this.asideList[i].children[j].url) {
                  this.children[0].children = this.asideList[i].children;
                  this.children[0].text = this.asideList[i].text;
                  this.isAsidetwo = j;
                  // console.log(this.isChildren)
                  return false;
                }
              }
            }
          }
        }
      }
    },

    scrollAside() {
      if (!this.isAside) {
        var scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop >= 216) {
          this.hidasideClass = "hidasidetransition hidasidepos";
          this.asideClass = "asideleft asidetransition";
          this.hidasideinsideclass = "hidaside hidasideheight";
          this.isGundong = true;
        } else {
          this.hidasideClass = "hidasidetransition";
          this.asideClass = "asideleft asidetransition";
          this.hidasideinsideclass = "hidaside";
          this.isGundong = false;
        }
      }
    },

    goDown() {
      this.$router.push({
        path: "/shareAndPush/myDownload",
      });
    },
  },
  mounted() {
    window.addEventListener("scroll", this.scrollAside, true);
  },
  created() {
    this.getSimple();
    this.refHandler(this.$route);
    this.bus.$on("changeIsaside", (message) => {
      this.bus.val = message;
      this.isAside = this.bus.val;
      // this.isChildren = false
    });
  },
  destroyed() {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.scrollAside);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./myelaside.scss";
</style>
